import { useState } from "react";
import "../../assets/css/product.scss";

import closeSvg from "../../assets/images/icons/close.svg";
import arrowBackSvg from "../../assets/images/icons/arrow_back.svg";

function DonateStep1Modal({ isOpen, onClose, onSuccess, onBack }) {
  const [paymentSelect, setPaymentSelect] = useState("subscription"); // subscription or single

  const reset = () => {
    setPaymentSelect("subscription");
  };

  if (!isOpen) return null;

  return (
    <div className="product-donate-modal modal-wrap">
      <div
        className="overlay"
        onClick={() => {
          onClose();
          reset();
        }}
      >
        <div className="modal" onClick={(e) => e.stopPropagation()}>
          <div>
            <button
              className={`backBtn`}
              onClick={() => {
                reset();
                onBack();
              }}
            >
              <img src={arrowBackSvg} alt="" />
            </button>
            <button
              className="closeBtn"
              onClick={() => {
                onClose();
                reset();
              }}
            >
              <img src={closeSvg} alt="" />
            </button>
          </div>
          <ul className="content">
            <li>Business</li>
            <li className="title">결제 유형을 선택해주세요</li>
            <li className="payment-select">
              <ul>
                <li>
                  <button
                    className={paymentSelect === "subscription" && `on`}
                    onClick={() => setPaymentSelect("subscription")}
                  >
                    매월 정기 결제
                  </button>
                </li>
                <li>신용카드</li>
              </ul>
              <ul>
                <li>
                  <button
                    className={paymentSelect === "single" && `on`}
                    onClick={() => setPaymentSelect("single")}
                  >
                    일반 결제
                  </button>
                </li>
                <li>신용카드 / 계좌이체</li>
              </ul>
            </li>
            <li className="submit">
              <button
                onClick={async () => {
                  onSuccess && onSuccess(paymentSelect);
                  reset();
                }}
              >
                다음
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default DonateStep1Modal;
